// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PvU-4","actions":"styles_actions__42768","labels":"styles_labels__Frmk1"};